import { HeadCell, ACTION } from '../../../../component/table/interfaces/TableInterface';


export const HEAD_CELL: Array<HeadCell> = [
    { id: 'id', label: 'ID Bandeira' },
    { id: 'idCrm', label: 'ID CRM' },
    { id: 'flag', label: 'Bandeira' },
    // { id: 'description', label: 'Descrição'},
    { id: 'directorName', label: 'Diretor da Bandeira' },
    { id: 'directorPhone', label: 'Dir. Telefone' },
    { id: ACTION, label: 'Ação' }
];

